import Model from 'js-model';

export default new Model({
  username: '',
  password: ''
});
